var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnswerIncorrectIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.000854492,
    width: 25,
    height: 25,
    rx: 5,
    fill: "#FF0000"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1203_2815)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7578 19.2434C18.1679 19.6534 18.8327 19.6534 19.2428 19.2434C19.6528 18.8333 19.6528 18.1685 19.2428 17.7585L13.9852 12.5009L19.2428 7.24336C19.6528 6.83331 19.6528 6.16849 19.2428 5.75844C18.8327 5.34838 18.1679 5.34838 17.7578 5.75843L12.5003 11.016L7.24273 5.75843C6.83268 5.34838 6.16786 5.34838 5.75781 5.75843C5.34776 6.16848 5.34776 6.83331 5.75781 7.24336L11.0154 12.5009L5.75781 17.7585C5.34776 18.1685 5.34776 18.8333 5.75781 19.2434C6.16786 19.6534 6.83268 19.6534 7.24273 19.2434L12.5003 13.9858L17.7578 19.2434Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1203_2815"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(19.5 5.50085) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnswerIncorrectIc);
export default __webpack_public_path__ + "static/media/answer_incorrect_ic.78f7b9060d7585bb46d01471411b073a.svg";
export { ForwardRef as ReactComponent };